import { spacing } from "../../primitives/spacing";
import type { SpacingTheme } from "../../semantic/spacing";

export const baseSpacing: SpacingTheme = {
  none: spacing[0],
  xs: spacing[1],
  sm: spacing[2],
  md: spacing[4],
  lg: spacing[6],
  xl: spacing[8],
  "2xl": spacing[12],
  "3xl": spacing[16],
  "4xl": spacing[24],
};
